import { WithStyles } from '@material-ui/core';
import styles from './VehicleSearch.styles';
import { IAutoISearchVehicleResponse } from 'api/swaggerTypes';

export interface IVehicleSearchProps extends WithStyles<typeof styles> {
  catalogueTypes: ICatalogueTypeItem[];
  defaultCatalogueTypeId?: number;
  vehicleMainStyle?: any;
  getCatalogueTypeStatesList(CatalogueTypeId: number): Promise<any>;
  searchVehicle(payload: any): Promise<IAutoISearchVehicleResponse>;
  manualVehicleSearch(CatalogueTypeId: number, Criteria?: any): Promise<IAutoISearchVehicleResponse>;
  onCatalogueTypeChage(CatalogueTypeId: number): void;
}

export interface ICatalogueTypeItem {
  catalogueTypeId: number;
  catalogueType: string;
  isAttributeSearchEnabled: boolean;
  isRegoSearchEnabled: boolean;
  isSmartSearchEnabled: boolean;
}

export const MANUAL_TRIAL_MINUS = 2;

export const mapCatalogueTypes = (apiResponse: any[]): { id: number; label: string; value: number }[] => {
  return apiResponse?.map((item) => ({
    id: item.catalogueTypeId,
    label: item.catalogueType,
    value: item.catalogueTypeId,
  }));
};

const SEARCH_SCREEN_DIALOG_STYLE = {
  width: 'calc(71%)',
  maxWidth: 'calc(71%)',
  height: 'calc(100% - 300px)',
  maxHeight: 'calc(100% - 300px)',
};

export const tabbedLookupProps = {
  loading: false,
  showSummaryPanel: false,
  customModuleTree: [
    { id: 'Lookup', label: 'Lookup', parent: '' },
  ],
  title: 'Vehicle Lookup',
  searchType: 'lookup' as 'lookup',
  allowArrowKeysNavigation: true,
  allowPostSearchSelectionActions: true,
  columnAutoWidth: true,
  dialogStyle: SEARCH_SCREEN_DIALOG_STYLE
};

export const encodeHtml = (str: string) => {
  const div = document.createElement('div');
  div.textContent = str;

  return div.innerHTML;
};
